/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Output_LocaleInputs */

const en_output_locale = /** @type {(inputs: Output_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output Locale`)
};

const fr_output_locale = /** @type {(inputs: Output_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locale de sortie`)
};

const de_output_locale = /** @type {(inputs: Output_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgabegebietsschema`)
};

const it_output_locale = /** @type {(inputs: Output_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni locali di output`)
};

const ru_output_locale = /** @type {(inputs: Output_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Локаль вывода`)
};

const es_output_locale = /** @type {(inputs: Output_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración regional de salida`)
};

const zh_cn2_output_locale = /** @type {(inputs: Output_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出区域设置`)
};

const ja_output_locale = /** @type {(inputs: Output_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力ロケール`)
};

const hi_output_locale = /** @type {(inputs: Output_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आउटपुट लोकेल`)
};

const pt_pt2_output_locale = /** @type {(inputs: Output_LocaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local de saída`)
};

/**
* | output |
* | --- |
* | "Output Locale" |
*
* @param {Output_LocaleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const output_locale = /** @type {((inputs?: Output_LocaleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Output_LocaleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_output_locale(inputs)
	if (locale === "de") return de_output_locale(inputs)
	if (locale === "it") return it_output_locale(inputs)
	if (locale === "ru") return ru_output_locale(inputs)
	if (locale === "es") return es_output_locale(inputs)
	if (locale === "zh-CN") return zh_cn2_output_locale(inputs)
	if (locale === "ja") return ja_output_locale(inputs)
	if (locale === "hi") return hi_output_locale(inputs)
	if (locale === "pt-PT") return pt_pt2_output_locale(inputs)
	return en_output_locale(inputs)
});